// src/components/common/NetworkStatusManager.tsx

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNetworkStatus } from '@config/useNetworkStatus'; // Adjust path to your hook
import { setNetworkStatus } from '@store/networkSlice'; // Adjust path to your slice
import { AppDispatch } from '@store/store';

// This is a "headless" component - it renders nothing.
// Its only purpose is to sync the network status with the Redux store.
const NetworkStatusManager: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const networkStatus = useNetworkStatus(); // Your existing detection hook

    useEffect(() => {
        // Whenever the network status from the hook changes,
        // dispatch an action to update the Redux store.
        dispatch(setNetworkStatus(networkStatus));
    }, [networkStatus]); // Dependency array ensures this runs only when status changes

    return null;
};

export default NetworkStatusManager;